export const pluginConfig = {
  lang: 'en',
  position: 'bottom-right',
  offset: [20, 20],
  size: 58,
  buttonIcon: null
};